module.exports = __webpack_public_path__ + "img/ufo.b91ef7be.svg";